import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, InputGroup, Input } from 'reactstrap';
import { Btn, H3, Breadcrumbs, P } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { addCoupon, addNotificationSettings, getAllUsers, getIndustry, getNotificationDetails, getStatus, updateNotification } from "../../../CommonURL";
import { getData, getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import DatePicker from 'react-datepicker';
import Typeahead from "../../../CommonElements/TypeAhead";
import { CouponName, Code, Type, Discount, StartDate, EndDate, UsersPerCoupon, UsersPerCustomer, SubmitForm, AddCoupon, Status, Industry, whatsAPP, SMSActive, NotificationSettings, addNotification, editNotification } from '../../../Constant';
import '../../../Style/AdminStyle.scss';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from 'moment';
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { toast } from "react-toastify";

const schema = yup.object().shape({
    user: yup.mixed().required().label('User'),
    industry: yup.mixed().required().label('Industry'),
    whatsApp: yup.string().required().label('whatsApp activate'),
    sms: yup.string().required().label('SMS Activate'),
});

const AddEditNotificationSettings = () => {
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = useState(false);
    const [userOption, setUserOption] = useState([])
    const [indusrtyOption, setIndustry] = useState([])
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const settingsId = params.get("id");




    const handlegetusers = async (id) => {
        const responce = await postDataWithToken(getAllUsers, { industry_id: id })
        if (responce?.data.status == true) {
            const option = responce?.data?.data?.map((item) => (
                {
                    value: item?.id,
                    label: item?.user_name
                }
            ))

            setUserOption(option)
        }

    }

    const handlegetIntrusty = async () => {

        const service = await getDataWithToken(getIndustry);
        const serviceOptions = service.data.map((e) => ({
            value: e.id,
            label: e.name,
        }))
        if (settingsId) {

        }
        setIndustry(serviceOptions);

    }

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            user_id: data.user?.value,
            industry_id: data.industry.value,
            sms_enabled: data?.sms,
            whatsapp_enabled: data?.whatsApp,
            ...(settingsId && { notification_id: settingsId })

        }
        const addPackageResponse = await postDataWithToken(settingsId ? updateNotification : addNotificationSettings, postRequest);
        if (addPackageResponse.data.status === true) {
            toast.success(addPackageResponse.data.message);
            navigate(`${process.env.PUBLIC_URL}/configuration/notification-settings`);

        } else {
            toast.error(addPackageResponse.data.message);
        }
        setLoading(false);
    };

    //get edit notfication settings details
    const handleGetSettingsData = async () => {
        setLoading(true

        )
        const responce = await getDataWithToken(getNotificationDetails + `?notification_id=${settingsId}`)
        if (responce?.status == true) {
            setValue('user', {
                label: responce?.data?.user_name,
                value: responce?.data?.user_id
            })
            handlegetusers(responce?.data?.industry_id)
            setValue('industry', {
                label: responce?.data?.industry_name,
                value: responce?.data?.industry_id
            })
            setValue('sms', responce?.data?.sms_enabled)
            setValue('whatsApp', responce?.data?.whatsapp_enabled)

        }
        setLoading(false)

    }

    useEffect(() => {
        handlegetIntrusty()
        if (settingsId) {
            handleGetSettingsData()
        }
    }, [])

    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}

            <Breadcrumbs mainTitle='Notification Setting' parent="Configuration" title="Notification Setting" />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{
                        settingsId ? editNotification : addNotification}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3">

                            <Col md='6'>
                                <Label className="form-label" >{Industry} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="industry"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            disabled={settingsId}
                                            options={indusrtyOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setValue('user', null)
                                                handlegetusers(value?.value)

                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors?.industry?.message}</p>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" >User <span className="requireStar">*</span></Label>
                                <Controller
                                    name="user"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            disabled={settingsId}
                                            options={userOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}

                                        />
                                    )}
                                />
                                <p className="text-danger">{errors?.user?.message}</p>
                            </Col>

                            <Col md='6'>
                                <Label className="form-label" for="discount">{whatsAPP} <span className="requireStar">*</span></Label>

                                <div>

                                    <input value={'yes'}  {...register("whatsApp")} name="whatsApp" type="radio" />
                                    <span className="mx-2">Yes</span>
                                </div>
                                <div>

                                    <input value={'no'} {...register("whatsApp")} name="whatsApp" type="radio" />
                                    <span className="mx-2">No</span>
                                </div>
                                <p className="text-danger">{errors?.whatsApp?.message}</p>
                            </Col>


                            <Col md="6">
                                <Label className="form-label" for="use_per_customer">{SMSActive} <span className="requireStar">*</span></Label>
                                <div>

                                    <input value={'yes'}  {...register("sms")} name="sms" type="radio" />
                                    <span className="mx-2">Yes</span>
                                </div>
                                <div>

                                    <input value={'no'}  {...register("sms")} name="sms" type="radio" />
                                    <span className="mx-2">No</span>
                                </div>
                                <p className="text-danger">{errors.sms?.message}</p>

                            </Col>


                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{SubmitForm}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default AddEditNotificationSettings;
